import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.chatbot');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-chatbot',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.chatbot/view.scss */
:host {
  display: block;
  height: 100%;
}

.chatbot-start-page {
  min-height: 0;
  overflow: hidden;
}

.chatbot-start-page.has-history,
.legacy-roomy-controls.has-history {
  gap: 16px;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  padding: 10px !important;
}

.chatbot-start-inspection {
  height: min(760px, 100vh - 48px);
  max-height: 100%;
}

.chatbot-start-page.has-history .chatbot-start-inspection {
  flex: 1 1 auto;
  max-width: none !important;
}

.chatbot-start-card {
  height: 100%;
  min-height: 0;
}

.chatbot-start-history {
  width: clamp(320px, 18vw, 365px);
  height: min(760px, 100vh - 48px);
  max-height: 100%;
  min-width: 0;
}

.legacy-roomy-controls .chatbot-start-history {
  flex: 0 0 clamp(320px, 18vw, 365px);
}

.legacy-roomy-controls.has-history > div:not(.chatbot-start-history) {
  flex: 1 1 auto;
  width: auto !important;
  max-width: none !important;
  min-width: 0 !important;
}

.legacy-roomy-controls .roomy-button,
.legacy-roomy-controls td > button {
  box-sizing: border-box;
  min-height: 22px;
  padding: 3px 9px !important;
  line-height: 1.35;
}
.legacy-roomy-controls .roomy-badge,
.legacy-roomy-controls td > span {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  padding: 2px 7px !important;
  line-height: 1.35;
}

.history-title,
.history-summary {
  min-width: 0;
  overflow: hidden;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.history-title {
  white-space: nowrap;
  text-overflow: ellipsis;
}

.history-summary {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.35;
}

.chatbot-history-modal {
  background: rgba(15, 23, 42, 0.36);
  backdrop-filter: blur(2px);
}

.chatbot-history-dialog {
  min-height: min(620px, 100vh - 48px);
  max-height: min(82vh, 720px);
}

.chatbot-history-list {
  overscroll-behavior: contain;
}

@media (min-width: 768px) {
  .chatbot-history-modal {
    display: none !important;
  }
}
@media (max-width: 767px) {
  .chatbot-start-page {
    align-items: stretch !important;
    justify-content: stretch !important;
    min-height: 0;
    overflow: hidden;
    padding: 10px !important;
  }
  .chatbot-start-inspection {
    width: 100% !important;
    max-width: none !important;
    height: 100%;
    min-width: 0 !important;
    min-height: 0;
    flex: 1 1 auto !important;
  }
  .chatbot-start-history {
    display: none !important;
  }
  .chatbot-start-card {
    border-radius: 10px !important;
    max-height: none !important;
  }
  .chatbot-start-card > div:first-child,
  .chatbot-start-body {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
  .chatbot-start-card > div:first-child {
    padding-top: 14px !important;
    padding-bottom: 14px !important;
  }
  .chatbot-start-body {
    padding-top: 14px !important;
    padding-bottom: 14px !important;
  }
  .chatbot-history-open-button {
    min-height: 34px;
  }
  .chatbot-history-modal {
    align-items: center !important;
    padding: 8px !important;
  }
  .chatbot-history-dialog {
    min-height: 0;
    max-height: calc(100dvh - 16px);
    border-radius: 10px !important;
  }
  .chatbot-history-header,
  .chatbot-history-toolbar {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
  .chatbot-history-header {
    align-items: flex-start;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }
  .chatbot-start-inspection p,
  .chatbot-start-inspection span,
  .chatbot-history-dialog span,
  .chatbot-history-dialog button {
    word-break: keep-all;
  }
  .legacy-roomy-controls {
    align-items: stretch !important;
    justify-content: stretch !important;
    overflow: hidden;
    padding: 10px !important;
  }
  .legacy-roomy-controls > div:first-child {
    width: 100% !important;
    max-width: none !important;
    min-width: 0 !important;
    height: 100%;
    min-height: 0;
    overflow-y: auto;
  }
  .legacy-roomy-controls input,
  .legacy-roomy-controls button {
    max-width: 100%;
  }
}`],
})
export class PageChatbotComponent implements OnInit, OnDestroy {
    public theme: string = 'modern';
    public colorMode: string = 'light';
    public showHistoryModal: boolean = false;
    public showHistoryPanel: boolean = false;
    public isMobileLayout: boolean = false;
    public loading: boolean = false;
    public creating: boolean = false;
    private readonly draftStorageKey: string = 'inspection.chatbot.draft.v1';
    private readonly colorModeStorageKey: string = 'ui-color-mode';

    // Drive 폴더 선택
    public reportFolder: any = null;
    public reportFiles: any[] = [];
    public selectedReportFileIds: { [key: string]: boolean } = {};

    // Drive 브라우저 상태
    public browsing: boolean = false;
    public browseFolders: any[] = [];
    public browseFiles: any[] = [];
    public browseCurrentFolder: string = '';
    public browseBreadcrumb: any[] = [];

    // Session History
    public sessions: any[] = [];
    public loadingSessions: boolean = false;
    public loadingMoreSessions: boolean = false;
    public hasMoreSessions: boolean = false;
    public sessionPage: number = 1;
    public readonly sessionLimit: number = 30;
    public selectedSessionIds: { [key: string]: boolean } = {};
    public historySelectionMode: boolean = false;
    public dailySessionQuota: any = null;

    private readonly viewportResizeHandler = () => this.onViewportResize();

    constructor(@Inject( Service) public service: Service) { }

    public async openHistoryModal(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.updateMobileLayout();
        if (this.isMobileLayout) {
            this.showHistoryModal = true;
        } else {
            this.showHistoryModal = false;
            this.showHistoryPanel = true;
        }
        await this.service.render();
    }

    public async closeHistoryModal(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.showHistoryModal = false;
        this.historySelectionMode = false;
        this.selectedSessionIds = {};
        await this.service.render();
    }

    public async ngOnInit() {
        await this.service.init();
        this.updateMobileLayout();
        this.showHistoryPanel = !this.isMobileLayout;
        window.addEventListener('resize', this.viewportResizeHandler);
        this.theme = localStorage.getItem('ui-theme') || 'modern';
        this.applyColorMode(this.storedColorMode(), false);
        if (!this.service.auth.allow(this.loginRedirect())) return;
        this.restoreDraft();
        this.loadingSessions = true;
        await this.service.render();
        setTimeout(() => {
            this.loadSessions(true);
        }, 0);
    }

    private loginRedirect() {
        const path = `${location.pathname}${location.search}${location.hash}`;
        return `/access?returnTo=${encodeURIComponent(path || '/chatbot')}`;
    }

    public ngOnDestroy() {
        window.removeEventListener('resize', this.viewportResizeHandler);
    }

    public get historyModalVisible(): boolean {
        return this.showHistoryModal && this.isMobileLayout;
    }

    public get historyPanelVisible(): boolean {
        return !this.isMobileLayout && this.showHistoryPanel;
    }

    private detectMobileLayout(): boolean {
        try {
            return window.matchMedia('(max-width: 767px)').matches;
        } catch (e) {
            return window.innerWidth <= 767;
        }
    }

    private updateMobileLayout(): boolean {
        const next = this.detectMobileLayout();
        const changed = this.isMobileLayout !== next;
        this.isMobileLayout = next;
        return changed;
    }

    private onViewportResize() {
        const modalWasOpen = this.showHistoryModal;
        if (!this.updateMobileLayout()) return;
        this.showHistoryPanel = !this.isMobileLayout;
        this.showHistoryModal = this.isMobileLayout && modalWasOpen;
        this.service.render();
    }

    private normalizeColorMode(value: any): string {
        return String(value || '').trim().toLowerCase() === 'dark' ? 'dark' : 'light';
    }

    private storedColorMode(): string {
        try {
            return this.normalizeColorMode(localStorage.getItem(this.colorModeStorageKey));
        } catch (e) {
            return 'light';
        }
    }

    private applyColorMode(value: any, persist: boolean = true) {
        const mode = this.normalizeColorMode(value);
        const isDark = mode === 'dark';
        this.colorMode = mode;
        try {
            if (persist) localStorage.setItem(this.colorModeStorageKey, mode);
        } catch (e) { }
        try {
            document.documentElement.classList.toggle('ui-dark', isDark);
            document.documentElement.classList.toggle('ui-light', !isDark);
            document.documentElement.style.colorScheme = mode;
            if (document.body) {
                document.body.classList.toggle('ui-dark', isDark);
                document.body.classList.toggle('ui-light', !isDark);
                document.body.style.colorScheme = mode;
            }
        } catch (e) { }
    }

    public async toggleColorMode(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.applyColorMode(this.colorMode === 'dark' ? 'light' : 'dark');
        await this.service.render();
    }

    private saveDraft() {
        try {
            if (!this.reportFolder) {
                sessionStorage.removeItem(this.draftStorageKey);
                return;
            }
            sessionStorage.setItem(this.draftStorageKey, JSON.stringify({
                reportFolder: this.reportFolder,
                reportFiles: this.reportFiles || [],
                selectedReportFileIds: this.selectedReportFileIds || {},
                savedAt: Date.now(),
            }));
        } catch (e) { }
    }

    private restoreDraft() {
        try {
            const raw = sessionStorage.getItem(this.draftStorageKey);
            if (!raw) return;
            const draft = JSON.parse(raw);
            if (!draft?.reportFolder) return;
            this.reportFolder = draft.reportFolder;
            this.reportFiles = Array.isArray(draft.reportFiles) ? draft.reportFiles : [];
            this.selectedReportFileIds = draft.selectedReportFileIds || {};
        } catch (e) { }
    }

    private clearDraft() {
        try {
            sessionStorage.removeItem(this.draftStorageKey);
        } catch (e) { }
    }

    private getErrorMessage(error: any, fallback: string): string {
        if (!error) return fallback;
        if (typeof error === 'string') return error;
        if (error?.data?.message) return error.data.message;
        if (error?.responseJSON?.data?.message) return error.responseJSON.data.message;
        if (error?.responseJSON?.message) return error.responseJSON.message;
        if (error?.message) return error.message;
        try {
            const text = JSON.stringify(error);
            return text && text !== '{}' ? text : fallback;
        } catch (e) {
            return fallback;
        }
    }

    // ========== Session History ==========

    public async loadSessions(reset: boolean = true) {
        if (this.loadingSessions && !reset) return;
        if (this.loadingMoreSessions) return;
        const nextPage = reset ? 1 : this.sessionPage + 1;
        if (reset) {
            this.loadingSessions = true;
        } else {
            this.loadingMoreSessions = true;
        }
        await this.service.render();
        try {
            const res: any = await wiz.call('list_sessions', { limit: this.sessionLimit, page: nextPage });
            if (res.code === 200 && res.data?.sessions) {
                const rows = res.data.sessions || [];
                this.sessions = reset ? rows : this.sessions.concat(rows);
                this.dailySessionQuota = res.data.quota || this.dailySessionQuota;
                this.sessionPage = nextPage;
                this.hasMoreSessions = !!res.data?.has_more;
                this.pruneSelectedSessions();
            }
        } catch (e) { }
        this.loadingSessions = false;
        this.loadingMoreSessions = false;
        await this.service.render();
    }

    public async loadMoreSessions(event?: Event) {
        if (event) this.stopHistoryButtonEvent(event);
        if (!this.hasMoreSessions) return;
        await this.loadSessions(false);
    }

    public stopHistoryButtonEvent(event: Event) {
        event.stopPropagation();
        const anyEvent = event as any;
        if (typeof anyEvent.stopImmediatePropagation === 'function') {
            anyEvent.stopImmediatePropagation();
        }
    }

    public async openSession(session: any) {
        this.service.href(`/chatbot/room/${session.id}`);
    }

    public async handleHistorySessionClick(session: any, event: Event) {
        if (this.historySelectionMode) {
            await this.toggleSessionSelection(session, event);
            return;
        }
        this.openSession(session);
    }

    public getInspectionReportUrl(sessionId: string): string {
        return `/wiz/api/page.chatbot.room/serve_inspection_excel?session_id=${encodeURIComponent(sessionId || '')}`;
    }

    public downloadSessionReport(session: any, event: Event) {
        this.stopHistoryButtonEvent(event);
        if (!session?.id) return;
        window.open(this.getInspectionReportUrl(session.id), '_blank');
    }

    public async deleteSession(session: any, event: Event) {
        this.stopHistoryButtonEvent(event);
        const ok = await this.service.modal.show({
            title: '세션 삭제',
            message: '이 검사 세션을 삭제하시겠습니까?',
            action: '삭제',
            actionBtn: 'error',
        });
        if (!ok) return;
        try {
            const res: any = await wiz.call('delete_session', { session_id: session.id });
            if (res.code === 200) {
                this.sessions = this.sessions.filter((s: any) => s.id !== session.id);
                delete this.selectedSessionIds[session.id];
                if (this.sessions.length === 0) this.historySelectionMode = false;
                await this.service.render();
            } else {
                await this.service.modal.error(res.data?.message || '삭제에 실패했습니다.');
            }
        } catch (e) {
            await this.service.modal.error('삭제에 실패했습니다.');
        }
    }

    public get selectedSessionCount(): number {
        return this.getSelectedSessionIds().length;
    }

    public get selectedReportSessionCount(): number {
        return this.getSelectedReportSessions().length;
    }

    public isSessionSelected(session: any): boolean {
        return !!this.selectedSessionIds[session?.id];
    }

    public areAllSessionsSelected(): boolean {
        const ids = (this.sessions || []).map((s: any) => s.id).filter((id: string) => !!id);
        return ids.length > 0 && ids.every((id: string) => !!this.selectedSessionIds[id]);
    }

    public async toggleSessionSelection(session: any, event: Event) {
        this.stopHistoryButtonEvent(event);
        if (!session?.id) return;
        if (this.selectedSessionIds[session.id]) {
            delete this.selectedSessionIds[session.id];
        } else {
            this.selectedSessionIds[session.id] = true;
        }
        await this.service.render();
    }

    public async toggleAllSessionSelection(event: Event) {
        this.stopHistoryButtonEvent(event);
        if (this.areAllSessionsSelected()) {
            this.selectedSessionIds = {};
            await this.service.render();
            return;
        }
        const selected: { [key: string]: boolean } = {};
        for (const session of this.sessions || []) {
            if (session?.id) selected[session.id] = true;
        }
        this.selectedSessionIds = selected;
        await this.service.render();
    }

    public async enterHistorySelectionMode(event?: Event) {
        if (event) this.stopHistoryButtonEvent(event);
        this.historySelectionMode = true;
        await this.service.render();
    }

    public async exitHistorySelectionMode(event?: Event) {
        if (event) this.stopHistoryButtonEvent(event);
        this.historySelectionMode = false;
        this.selectedSessionIds = {};
        await this.service.render();
    }

    public async clearSessionSelection(event?: Event) {
        if (event) this.stopHistoryButtonEvent(event);
        this.selectedSessionIds = {};
        await this.service.render();
    }

    public async downloadSelectedSessionReports(event?: Event) {
        if (event) this.stopHistoryButtonEvent(event);
        const reportSessions = this.getSelectedReportSessions();
        if (reportSessions.length === 0) {
            await this.service.modal.error('선택한 이력에 받을 결과표가 없습니다.');
            return;
        }
        for (const session of reportSessions) {
            window.open(this.getInspectionReportUrl(session.id), '_blank');
        }
    }

    public async deleteSelectedSessions(event?: Event) {
        if (event) this.stopHistoryButtonEvent(event);
        const ids = this.getSelectedSessionIds();
        if (ids.length === 0) {
            await this.service.modal.error('삭제할 이력을 선택해주세요.');
            return;
        }
        const ok = await this.service.modal.show({
            title: '선택 세션 삭제',
            message: `${ids.length}개 검사 세션을 삭제하시겠습니까?`,
            action: '삭제',
            actionBtn: 'error',
        });
        if (!ok) return;
        try {
            const res: any = await wiz.call('delete_sessions', { session_ids: JSON.stringify(ids) });
            if (res.code === 200) {
                this.sessions = this.sessions.filter((s: any) => ids.indexOf(s.id) < 0);
                this.selectedSessionIds = {};
                this.historySelectionMode = false;
                await this.service.render();
            } else {
                await this.service.modal.error(res.data?.message || '삭제에 실패했습니다.');
            }
        } catch (e) {
            await this.service.modal.error('삭제에 실패했습니다.');
        }
    }

    private getSelectedSessionIds(): string[] {
        const existing = new Set((this.sessions || []).map((s: any) => s.id).filter((id: string) => !!id));
        return Object.keys(this.selectedSessionIds || {}).filter((id: string) => this.selectedSessionIds[id] && existing.has(id));
    }

    private getSelectedReportSessions(): any[] {
        const ids = this.getSelectedSessionIds();
        return (this.sessions || []).filter((session: any) => ids.indexOf(session.id) >= 0 && session.has_results);
    }

    private pruneSelectedSessions() {
        const selected: { [key: string]: boolean } = {};
        for (const id of this.getSelectedSessionIds()) {
            selected[id] = true;
        }
        this.selectedSessionIds = selected;
        if ((this.sessions || []).length === 0) {
            this.historySelectionMode = false;
        }
    }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '';
        try {
            const d = new Date(dateStr);
            const now = new Date();
            const diffMs = now.getTime() - d.getTime();
            const diffMin = Math.floor(diffMs / 60000);
            const diffHour = Math.floor(diffMs / 3600000);
            const diffDay = Math.floor(diffMs / 86400000);
            if (diffMin < 1) return '방금 전';
            if (diffMin < 60) return `${diffMin}분 전`;
            if (diffHour < 24) return `${diffHour}시간 전`;
            if (diffDay < 7) return `${diffDay}일 전`;
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            const hh = String(d.getHours()).padStart(2, '0');
            const mi = String(d.getMinutes()).padStart(2, '0');
            return `${mm}/${dd} ${hh}:${mi}`;
        } catch { return dateStr; }
    }

    public getFileTypeSummary(fileTypes: any): string {
        const labels: any = {
            report: '보고서', reference: '전차', kickoff: '착수계',
            contract: '계약서', ledger: '관리대장', additional: '추가',
        };
        return Object.entries(fileTypes || {})
            .map(([k, v]) => `${labels[k] || k} ${v}`)
            .join(', ');
    }

    public getSessionTitle(session: any): string {
        return session?.service_name || session?.report_folder_name || session?.filenames?.[0] || '검사 세션';
    }

    public getSessionSummary(session: any): string {
        return session?.conversation_summary || session?.first_question || '대화 요약이 없습니다';
    }

    private quotaNumber(value: any): number {
        const num = Number(value);
        return Number.isFinite(num) ? num : 0;
    }

    public get isDailySessionQuotaVisible(): boolean {
        return !!this.dailySessionQuota && this.dailySessionQuota.limited !== false;
    }

    public get isDailySessionQuotaExceeded(): boolean {
        return this.isDailySessionQuotaVisible && this.dailySessionQuota.allowed === false;
    }

    public get dailySessionQuotaText(): string {
        if (!this.isDailySessionQuotaVisible) return '';
        const used = this.quotaNumber(this.dailySessionQuota.used);
        const limit = this.quotaNumber(this.dailySessionQuota.limit);
        const remaining = Math.max(0, this.quotaNumber(this.dailySessionQuota.remaining));
        return `오늘 세션 ${used}/${limit} · 남은 ${remaining}개`;
    }

    public get dailySessionQuotaNotice(): string {
        if (!this.isDailySessionQuotaExceeded) return '';
        return this.dailySessionQuota?.message || '오늘 만들 수 있는 검사 세션을 모두 사용했습니다.';
    }

    public canStartInspection(): boolean {
        return this.reportFiles.length > 0 && !this.isDailySessionQuotaExceeded && !this.creating;
    }

    // ========== Drive Browse ==========

    public async openBrowser() {
        this.browsing = true;
        this.browseCurrentFolder = '';
        this.browseBreadcrumb = [];
        await this.loadDriveFolder('');
        await this.service.render();
    }

    public closeBrowser() {
        this.browsing = false;
    }

    public async loadDriveFolder(folderId: string) {
        this.loading = true;
        await this.service.render();
        try {
            const res: any = await wiz.call('drive_list', { folder_id: folderId });
            if (res.code === 200) {
                this.browseFolders = res.data.folders || [];
                this.browseFiles = res.data.files || [];
                this.browseCurrentFolder = res.data.current_folder || '';
                this.browseBreadcrumb = res.data.breadcrumb || [];
                this.resetBrowseSelection();
            }
        } catch (e) { }
        this.loading = false;
        await this.service.render();
    }

    public async browseNavigate(folderId: string) {
        await this.loadDriveFolder(folderId);
    }

    public async browseGoRoot() {
        await this.loadDriveFolder('');
    }

    public isMissingFile(file: any): boolean {
        return !!file && (file.missing_on_disk === true || file.disk_exists === false || file.downloadable === false);
    }

    private async showMissingDriveFiles(files: any[]) {
        const firstName = files[0]?.name || '선택한 파일';
        const suffix = files.length > 1 ? ` 외 ${files.length - 1}개` : '';
        await this.service.modal.show({
            title: '원본 파일 없음',
            message: `${firstName}${suffix}의 원본 파일이 서버 디스크에 없습니다. 프로젝트 복사 시 data/drive 폴더가 함께 복사되지 않은 것 같습니다. 파일을 다시 업로드해주세요.`,
            action: '확인',
            cancel: false,
            status: 'warning',
        });
    }

    public isInspectableFile(file: any): boolean {
        if (this.isMissingFile(file)) return false;
        const name = String(file?.name || file?.filename || '').toLowerCase();
        return name.endsWith('.pdf') || name.endsWith('.hwp') || name.endsWith('.hwpx');
    }

    public get browsePdfCount(): number {
        return this.browseFiles.filter((f: any) => this.isInspectableFile(f)).length;
    }

    public get browseInspectableCount(): number {
        return this.browseFiles.filter((f: any) => this.isInspectableFile(f)).length;
    }

    public get browseSelectedCount(): number {
        return this.browseFiles.filter((f: any) => this.isInspectableFile(f) && this.isBrowseFileSelected(f)).length;
    }

    private resetBrowseSelection() {
        this.selectedReportFileIds = {};
        for (const file of this.browseFiles) {
            if (this.isInspectableFile(file) && file.id) {
                this.selectedReportFileIds[file.id] = true;
            }
        }
    }

    public isBrowseFileSelected(file: any): boolean {
        if (!file?.id) return false;
        return this.selectedReportFileIds[file.id] !== false;
    }

    public async toggleBrowseFile(file: any, event: Event) {
        const target = event.target as HTMLInputElement;
        if (file?.id) {
            this.selectedReportFileIds[file.id] = !!target.checked;
        }
        await this.service.render();
    }

    public async selectCurrentFolder() {
        const folderId = this.browseCurrentFolder;
        const folderName = this.browseBreadcrumb.length > 0
            ? this.browseBreadcrumb[this.browseBreadcrumb.length - 1].name
            : '루트';
        this.reportFolder = { id: folderId, name: folderName };
        this.reportFiles = this.browseFiles.filter((f: any) =>
            this.isInspectableFile(f) && this.isBrowseFileSelected(f)
        );
        this.browsing = false;
        this.saveDraft();
        await this.service.render();
    }

    public async removeReportFolder() {
        this.reportFolder = null;
        this.reportFiles = [];
        this.selectedReportFileIds = {};
        this.clearDraft();
        await this.service.render();
    }

    public async removeReportFile(file: any, event?: Event) {
        if (event) event.stopPropagation();
        this.reportFiles = this.reportFiles.filter((f: any) => f.id !== file.id);
        if (file?.id) {
            this.selectedReportFileIds[file.id] = false;
        }
        this.saveDraft();
        await this.service.render();
    }

    public async toggleSelectedReportFile(file: any, event: Event) {
        const target = event.target as HTMLInputElement;
        if (!target.checked) {
            await this.removeReportFile(file, event);
            return;
        }
        if (file?.id) {
            this.selectedReportFileIds[file.id] = true;
        }
        this.saveDraft();
        await this.service.render();
    }

    public formatSize(bytes: number): string {
        if (!bytes) return '0 B';
        if (bytes < 1024) return bytes + 'B';
        if (bytes < 1048576) return (bytes / 1024).toFixed(1) + 'KB';
        return (bytes / 1048576).toFixed(1) + 'MB';
    }

    // ========== Start Inspection ==========

    public async startInspection() {
        if (!this.reportFolder || this.creating) return;
        if (this.isDailySessionQuotaExceeded) {
            await this.service.render();
            return;
        }
        if (this.reportFiles.length === 0) {
            await this.service.modal.show({
                title: '검사 파일 없음',
                message: '검사할 파일을 한 개 이상 선택해주세요.',
                action: '확인',
                cancel: false,
                status: 'warning',
            });
            return;
        }

        const missingFiles = this.reportFiles.filter((file: any) => this.isMissingFile(file));
        if (missingFiles.length > 0) {
            await this.showMissingDriveFiles(missingFiles);
            return;
        }

        this.creating = true;
        await this.service.render();

        try {
            const reportFileIds = this.reportFiles.map((f: any) => f.id);

            const res: any = await wiz.call('create_from_drive', {
                report_folder_id: this.reportFolder.id,
                report_folder_name: this.reportFolder.name,
                report_file_ids: JSON.stringify(reportFileIds),
            });

            if (res.code === 200 && res.data?.session_id) {
                this.clearDraft();
                this.service.href(`/chatbot/room/${res.data.session_id}`);
                return;
            }

            await this.service.modal.show({
                title: '검사 시작 실패',
                message: res.data?.message || '검사 세션을 만들지 못했습니다.',
                action: '확인',
                cancel: false,
                status: 'error',
            });
        } catch (e: any) {
            await this.service.modal.show({
                title: '검사 시작 실패',
                message: this.getErrorMessage(e, '검사 세션을 만들지 못했습니다.'),
                action: '확인',
                cancel: false,
                status: 'error',
            });
        }

        this.creating = false;
        await this.service.render();
    }
}

export default PageChatbotComponent;
